export const getPath = ({ category }) => `/faq/${category}`
